import { PendingCitationsState } from './pending-citations.state';
import { PendingCitationResponse } from '@/api/pending-citations.api';
import { defaultApiState } from '@/store/types/general.types';
import { AxiosError } from 'axios';

export const pendingCitationsMutations = {
  GET_PENDING_CITATIONS_LOADING(
    state: PendingCitationsState,
    documentId: number
  ) {
    state.apiState.getPendingCitations = {
      ...defaultApiState,
      loading: true
    };
    if (state.citationsByDocumentId[documentId]) {
      delete state.citationsByDocumentId[documentId];
    }
  },
  GET_PENDING_CITATIONS_SUCCESS(
    state: PendingCitationsState,
    payload: { documentId: number; citations: PendingCitationResponse[] }
  ) {
    state.apiState.getPendingCitations = {
      ...defaultApiState,
      success: true
    };
    state.citationsByDocumentId[payload.documentId] = payload.citations;
    state.lastUpdated = Date.now();
  },
  GET_PENDING_CITATIONS_ERROR(state: PendingCitationsState, error: AxiosError) {
    state.apiState.getPendingCitations = {
      ...defaultApiState,
      error
    };
  },

  ADD_PENDING_CITATION_LOADING(state: PendingCitationsState) {
    state.apiState.addPendingCitation = {
      ...defaultApiState,
      loading: true
    };
  },
  ADD_PENDING_CITATION_SUCCESS(
    state: PendingCitationsState,
    payload: { documentId: number; citation: PendingCitationResponse }
  ) {
    state.apiState.addPendingCitation = {
      ...defaultApiState,
      success: true
    };
    if (!state.citationsByDocumentId[payload.documentId]) {
      state.citationsByDocumentId[payload.documentId] = [payload.citation];
    } else {
      state.citationsByDocumentId[payload.documentId] = [
        ...state.citationsByDocumentId[payload.documentId],
        payload.citation
      ];
    }
    state.lastUpdated = Date.now();
  },
  ADD_PENDING_CITATION_ERROR(state: PendingCitationsState, error: AxiosError) {
    state.apiState.addPendingCitation = {
      ...defaultApiState,
      error
    };
  },

  UPDATE_PENDING_CITATION_LOADING(state: PendingCitationsState) {
    state.apiState.updatePendingCitation = {
      ...defaultApiState,
      loading: true
    };
  },
  UPDATE_PENDING_CITATION_SUCCESS(
    state: PendingCitationsState,
    payload: { documentId: number; citation: PendingCitationResponse }
  ) {
    state.apiState.updatePendingCitation = {
      ...defaultApiState,
      success: true
    };
    const citations = state.citationsByDocumentId[payload.documentId];
    if (citations) {
      const index = citations.findIndex(
        (c) => c.citationId === payload.citation.citationId
      );
      if (index !== -1) {
        const updatedCitations = [...citations];
        updatedCitations[index] = payload.citation;
        state.citationsByDocumentId[payload.documentId] = updatedCitations;
      }
    }
    state.lastUpdated = Date.now();
  },
  UPDATE_PENDING_CITATION_ERROR(
    state: PendingCitationsState,
    error: AxiosError
  ) {
    state.apiState.updatePendingCitation = {
      ...defaultApiState,
      error
    };
  },

  DELETE_PENDING_CITATION_LOADING(state: PendingCitationsState) {
    state.apiState.deletePendingCitation = {
      ...defaultApiState,
      loading: true
    };
  },
  DELETE_PENDING_CITATION_SUCCESS(
    state: PendingCitationsState,
    payload: { documentId: number; citationId: number }
  ) {
    state.apiState.deletePendingCitation = {
      ...defaultApiState,
      success: true
    };
    const citations = state.citationsByDocumentId[payload.documentId];
    if (citations) {
      const index = citations.findIndex(
        (c) => c.citationId === payload.citationId
      );
      if (index !== -1) {
        citations.splice(index, 1);
      }
    }
    state.lastUpdated = Date.now();
  },
  DELETE_PENDING_CITATION_ERROR(
    state: PendingCitationsState,
    error: AxiosError
  ) {
    state.apiState.deletePendingCitation = {
      ...defaultApiState,
      error
    };
  },

  IMPORT_PENDING_CITATIONS_LOADING(state: PendingCitationsState) {
    state.apiState.importPendingCitations = {
      ...defaultApiState,
      loading: true
    };
  },
  IMPORT_PENDING_CITATIONS_SUCCESS(
    state: PendingCitationsState,
    payload: { documentId: number; citations: PendingCitationResponse[] }
  ) {
    state.apiState.importPendingCitations = {
      ...defaultApiState,
      success: true
    };
    if (!state.citationsByDocumentId[payload.documentId]) {
      state.citationsByDocumentId[payload.documentId] = [...payload.citations];
    } else {
      state.citationsByDocumentId[payload.documentId] = [
        ...state.citationsByDocumentId[payload.documentId],
        ...payload.citations
      ];
    }
    state.lastUpdated = Date.now();
  },
  IMPORT_PENDING_CITATIONS_ERROR(
    state: PendingCitationsState,
    error: AxiosError
  ) {
    state.apiState.importPendingCitations = {
      ...defaultApiState,
      error
    };
  },

  CLEAR_PENDING_CITATIONS(state: PendingCitationsState, documentId?: number) {
    if (documentId) {
      delete state.citationsByDocumentId[documentId];
    } else {
      state.citationsByDocumentId = {};
    }
    state.lastUpdated = Date.now();
  },

  ARCHIVE_PENDING_CITATION_LOADING(state: PendingCitationsState) {
    state.apiState.archivePendingCitation = {
      ...defaultApiState,
      loading: true
    };
  },
  ARCHIVE_PENDING_CITATION_ERROR(
    state: PendingCitationsState,
    error: AxiosError
  ) {
    state.apiState.archivePendingCitation = {
      ...defaultApiState,
      error
    };
  },

  RESTORE_PENDING_CITATION_LOADING(state: PendingCitationsState) {
    state.apiState.archivePendingCitation = {
      ...defaultApiState,
      loading: true
    };
  },
  RESTORE_PENDING_CITATION_ERROR(
    state: PendingCitationsState,
    error: AxiosError
  ) {
    state.apiState.archivePendingCitation = {
      ...defaultApiState,
      error
    };
  }
};
